module.exports = __webpack_public_path__ + "static/media/tp.ae84c569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/tp.png
// module id = 1304
// module chunks = 110